// extracted by mini-css-extract-plugin
export var content = "getXealCertified-module--content--1cd4f";
export var cta = "getXealCertified-module--cta--cec06";
export var section = "getXealCertified-module--section--6e72d";
export var text = "getXealCertified-module--text--7f73e";